import { render, staticRenderFns } from "./TeamCompare.vue?vue&type=template&id=4cd9b426&scoped=true"
import script from "./TeamCompare.vue?vue&type=script&lang=js"
export * from "./TeamCompare.vue?vue&type=script&lang=js"
import style0 from "./TeamCompare.vue?vue&type=style&index=0&id=4cd9b426&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9b426",
  null
  
)

export default component.exports